module.exports = __webpack_public_path__ + "static/img/4.80f61e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/eng/4.png
// module id = G8G3
// module chunks = 0